import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/messages";
import "@/filters";
import "@/fontawesome";
import "@/directives";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueMoment from "vue-moment";
import VueScrollTo from "vue-scrollto";
import ScrollLoader from "vue-scroll-loader";
import Multiselect from "vue-multiselect";
import VueCookies from 'vue-cookies';
import VueGtm from '@gtm-support/vue2-gtm'
import Clipboard from 'v-clipboard';
import VueGoogleCharts from 'vue-google-charts';
import { VuePlausible } from 'vue-plausible';

import { CONFIG } from '@/config.js';

if (CONFIG.gtmkey) {
    Vue.use(VueGtm, {
        id: CONFIG.gtmkey,
        vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        enabled: !!CONFIG.gtmkey
    });
}

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueAxios, axios);
Vue.use(VueMoment);
Vue.use(VueGoogleCharts);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 700,
    easing: "ease",
    offset: -80,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});
Vue.use(ScrollLoader);
Vue.component("vue-multiselect", Multiselect);
Vue.use(VueCookies)
Vue.use(Clipboard);

Vue.use(VuePlausible, {
    domain: CONFIG.plausibleDomain,
    trackLocalhost: true,
    apiHost: CONFIG.plausibleTrackingApi
})

// this can be enabled when the next version of plausible will be rolled oout
// currently the outbound tracking disables _blank behaviour
//Vue.$plausible.enableAutoOutboundTracking()
Vue.$plausible.enableAutoPageviews()

new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
}).$mount("#app");
